
<!-- modificacion de datos personales -->
<template>
    <div>
        <DialogoFotoCarnet ref="d_fotoCarnet" titulo="Foto carnet"></DialogoFotoCarnet>
        <v-card flat>
            <v-card-actions>
                <v-col md="12" cols="12">
                    <v-btn elevation="0" block class="pa-5" color="primary">
                        <v-icon class="mr-2">mdi-camera-outline</v-icon>
                        TOMAR FOTO
                    </v-btn>
                    <InputButtonD v-if="!$vuetify.breakpoint.mobile" :titulo="titulo" icono="mdi-folder-outline"
                        @fotoCargada="fotoSeleccionada" tipo="fotocarnet">
                    </InputButtonD>
                </v-col>
            </v-card-actions>
        </v-card>
        <!-- <div class="mt-2">
                    <InputButton titulo="cambiar foto carnet" icono="mdi-camera-outline" tipo="fotocarnet"></InputButton>
                </div> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InputButton from '@/components/inputs/InputButton.vue'
import InputButtonD from '@/components/inputs/InputButtonDialogoFoto.vue'
import DialogoFotoCarnet from '@/components/dialogos/DialogoFotoCarnet.vue'

export default {
    components: {
        InputButton,
        DialogoFotoCarnet,
        InputButtonD,
    },
    data() {
        return {
            //data select
            userAfi: {},
        }
    },
    computed: {
        ...mapGetters('auth', ['user', 'nroafi']),
        ...mapGetters('dataUser', ['fototmp', 'fotoCarnet']),
    },
    methods: {
        /* Metodos para 'tomar foto' */
        lanzarDialogFoto() {
            this.$refs.d_fotoCarnet.abrirDialogo()
        },
        /* Fin metodos 'tomar foto' */
        reciboCarnet() {
            this.$emit('isCorrectForm', { valid: true, index: this.index })
        },
        cambiarPanelFoto() {
            this.$emit('abrirCamera')
        },

    },
    mounted() {

    },
    props: ['index']
}


</script>